import { axiosFrontAgent } from "../axiosInstance";

export const ProcessController = Object.freeze({
  /**
   * id {string} - id процесса
   * data - Record<string, unknown>
   * */
  startProcess: (id, data) => axiosFrontAgent.post(`process/start/${id}`, data),
});
